var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { boundMethod } from 'autobind-decorator';
import { v4 as uuid } from 'uuid';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { formatPortsHelper } from 'components/powerFlowShared/helpers/nodePortFormatter';
import { FlowNode, flowNodeColor, NodeTypeComponent, } from 'fable/flowEditor';
import AnnounceFromPayload from '../helpers/announceFromPayload';
import { AudioMessage as ActionModal } from '../modals/audioMessage';
const portTranslator = (node) => {
    const outPorts = [];
    if (!node.payload.hangUpAfterAnnouncement) {
        outPorts.push({
            id: uuid(),
            type: 'out',
            label: 'arrow',
            connection: node.payload.afterAnnouncementNodeId || uuid(),
        });
    }
    return outPorts;
};
export class AudioMessageNode extends NodeTypeComponent() {
    triggerEdit() {
        const { onEdit, node } = this.props;
        onEdit(node, node.nodeType);
    }
    render() {
        return (_jsx(FlowNode, { color: AudioMessageNode.color, icon: AudioMessageNode.icon, label: AudioMessageNode.label, text: _jsx(AnnounceFromPayload, { node: this.props.node, extraData: this.props.extraData, text: "Audio file" }), onEdit: this.triggerEdit }));
    }
}
AudioMessageNode.icon = 'announcement';
AudioMessageNode.label = 'Audio message';
AudioMessageNode.helpText = 'Record or upload an audio message that’ll play when your customers call you (e.g. informing them when you’re closed for the holidays, asking to have an order number ready, etc.).';
AudioMessageNode.color = flowNodeColor.red;
AudioMessageNode.translatePayload = formatPortsHelper(portTranslator);
AudioMessageNode.ActionModal = ActionModal;
AudioMessageNode.actionTrigger = { type: FlowNodeTypes.AUDIO_MESSAGE };
AudioMessageNode.updateConnection = (node, _port, newConnection) => {
    const payload = Object.assign({}, node.payload);
    payload.afterAnnouncementNodeId = newConnection;
    return Object.assign(Object.assign({}, node), { payload });
};
__decorate([
    boundMethod
], AudioMessageNode.prototype, "triggerEdit", null);
